import React from "react"
import { Helmet } from "react-helmet"
import Museo_Slab_900 from "../media/fonts/Museo_Slab_900-webfont.woff2"
import Museo_Slab_700 from "../media/fonts/Museo_Slab_700-webfont.woff2"
const PageMeta = props => {
  const data = props.metaData

  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "local"
  const getPath = () => {
    switch (activeEnv) {
      case "test":
        return "test-"
      case "stage":
        return "stage-"
      default:
        return ""
    }
  }
  const path = getPath();

  const manifestPath =
    activeEnv === "local"
      ? "."
      : `https://${path}cdn.moneysavingexpert.com/eligibility`

  return (
    <Helmet>
      <meta name="fb:app_id" content="362661723751584" />
      <meta name="title" content={data.pageTitle} />
      <meta name="author" content="MoneySavingExpert.com" />
      <meta name="robots" content="index, follow" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={data.ogTitle} />
      <meta property="og:image" content={data.ogImage} />
      <meta property="og:url" content={data.ogUrl} />
      <meta property="og:description" content={data.description} />
      <meta property="og:site_name" content="MoneySavingExpert.com" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.ogTitle} />
      <meta name="twitter:description" content={data.description} />
      <meta name="twitter:image" content={data.ogImage} />
      <meta name="twitter:site" content="@MoneySavingExp" />
      <link rel="canonical" href={data.canonicalURL} />
      <link rel="manifest" href={`${manifestPath}/manifest.webmanifest`} />
      <title>{data.pageTitle}</title>
      <link
        rel="preload"
        as="font"
        href={Museo_Slab_700}
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="preload"
        as="font"
        href={Museo_Slab_900}
        type="font/woff2"
        crossOrigin="anonymous"
      />
      <link
        rel="shortcut icon"
        type="image/png"
        href="https://www.moneysavingexpert.com/etc/designs/zg/mse/desktop/assets/img/favicon.ico"
      ></link>
      <link
        rel="preconnect"
        href="https://cdn.moneysavingexpert.com"
        crossorigin
      />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
      <link rel="dns-prefetch" href="//static.chartbeat.com/js/chartbeat.js" />

      <meta class="swiftype" name="label" data-type="string" />
      <meta class="swiftype" name="label_id" data-type="enum" />
      <meta
        class="swiftype"
        name="category"
        data-type="string"
        content="Standalone-Tools"
      />
      <meta
        class="swiftype"
        name="headline"
        data-type="string"
        content={data.ogTitle}
      />
      <meta
        class="swiftype"
        name="description"
        data-type="string"
        content={data.description}
      />
    </Helmet>
  )
}

export default PageMeta
